
import { GameRole } from '../../types/game';
import { technicianRole } from './technician';
import { operationsRole } from './operations';
import { energyRole } from './energy';
import { engineerRole } from './engineer';
import { entrepreneurRole } from './entrepreneur';

export const gameRoles: GameRole[] = [
  technicianRole,
  operationsRole,
  energyRole,
  engineerRole,
  entrepreneurRole
];
